import {
  Header1,
  Instruction,
  InstructionWithButtonGroup,
  InstructionWithContent,
  InstructionWithImage,
} from "../../BlockComponent";
import {
  ButtonGroup,
  GuideTypographyLine,
  LineWithSolidLabel,
  TypographyLine,
} from "../../CellComponent";
import { LastCard } from "../common";

export const Content_12_3_A = [
  Header1("typography_0"),
  Instruction("typography_1"),
  InstructionWithImage("typography_2", "0"),

  Header1("typography_3"),
  Instruction("typography_4"),
  Instruction("typography_5"),

  InstructionWithButtonGroup(
    "typography_6",
    [
      { text: "네, 어떤 생각 때문인지 금방 알아차립니다." },
      { text: "아니요, 생각보다는 감정이나 몸의 느낌에 먼저 압도됩니다." },
      { text: "잘 모르겠습니다. 항상 모든 것이 뒤섞여 있는 것 같습니다." },
    ],
    { id: "thought_awareness", vertical: true }
  ),

  Header1("typography_7"),
  Instruction("typography_8"),
  Instruction("typography_9"),
  Instruction("typography_10"),
  Instruction("typography_11"),

  InstructionWithContent(`typography_12`, [
    ...LineWithSolidLabel("분노", TypographyLine("typography_emotion_anger")),
    ...LineWithSolidLabel(
      "혐오감",
      TypographyLine("typography_emotion_disgust")
    ),
    ...LineWithSolidLabel("부러움", TypographyLine("typography_emotion_envy")),
    ...LineWithSolidLabel("두려움", TypographyLine("typography_emotion_fear")),
    ...LineWithSolidLabel(
      "질투",
      TypographyLine("typography_emotion_jealousy")
    ),
    ...LineWithSolidLabel("슬픔", TypographyLine("typography_emotion_sadness")),
    ...LineWithSolidLabel("수치감", TypographyLine("typography_emotion_shame")),
    ...LineWithSolidLabel("죄책감", TypographyLine("typography_emotion_guilt")),
    ...LineWithSolidLabel(
      "행복",
      TypographyLine("typography_emotion_happiness")
    ),
    ...LineWithSolidLabel("사랑", TypographyLine("typography_emotion_love")),
  ]),
  Instruction("typography_13"),

  InstructionWithContent(`typography_14`, [
    [
      ButtonGroup(
        [
          { text: "A. 스스로가 초라해진 느낌" },
          { text: "B. 분노, 슬픔" },
          { text: "C. 얼굴이 붉어짐" },
        ],
        { id: "quiz_emotion", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz_emotion", answerIndex: 1 }],
    }),
  ]),
  Instruction("typography_15"),

  Header1("typography_16"),
  Instruction("typography_17"),
  Instruction("typography_18"),
  InstructionWithContent(`typography_19`, [
    ...LineWithSolidLabel("머리", TypographyLine("typography_body_head")),
    ...LineWithSolidLabel("얼굴/눈", TypographyLine("typography_body_face")),
    ...LineWithSolidLabel("목/어깨", TypographyLine("typography_body_neck")),
    ...LineWithSolidLabel("가슴", TypographyLine("typography_body_chest")),
    ...LineWithSolidLabel("배/위장", TypographyLine("typography_body_stomach")),
    ...LineWithSolidLabel("손/팔", TypographyLine("typography_body_arm")),
    ...LineWithSolidLabel("다리/발", TypographyLine("typography_body_leg")),
  ]),

  InstructionWithContent(`typography_20`, [
    [
      ButtonGroup(
        [
          { text: "A. 가슴이 답답해서 미칠 것 같음" },
          { text: "B. 가슴의 답답함" },
          { text: "C. 밖으로 뛰쳐나가고 싶음" },
        ],
        { id: "quiz_body1", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz_body1", answerIndex: 1 }],
    }),
  ]),
  Instruction("typography_21"),

  InstructionWithContent(`typography_22`, [
    [
      ButtonGroup(
        [
          { text: "A. 생각: '이번 시험은 망쳤어' / 신체 반응: 불안함" },
          {
            text: "B. 생각: '아무도 나를 돕지 않을 거야' / 신체 반응: 외로움",
          },
          {
            text: "C. 생각: '큰일 났다, 시간이 없어' / 신체 반응: 호흡이 가빠짐",
          },
        ],
        { id: "quiz_body2", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz_body2", answerIndex: 2 }],
    }),
  ]),
  Instruction("typography_23"),

  Header1("typography_24_v2"),
  Instruction("typography_25"),
  Instruction("typography_26_v2"),

  ...LastCard,
];
